import axios from 'axios'
import { MONTHLY_COMMISSIONS_ENDPOINT } from '../../endpoints'

export  async function getAvailablePeriods(carlotId, branchOfficeId, saleType) {
    const { data } = await axios.get(`${MONTHLY_COMMISSIONS_ENDPOINT}/getAvailablePeriods/${carlotId}/${branchOfficeId}/${saleType}`);
    return data?.data
}